import { FieldTypeFactory } from '@sentecacommerce-theme/base'
import { FooterProps } from './footer.props'

export const FooterTypeData: FooterProps = {
  menus: FieldTypeFactory.list({
    of: {
      label: FieldTypeFactory.text(),
      url: FieldTypeFactory.text({ required: false }),
      items: FieldTypeFactory.list({
        of: {
          label: FieldTypeFactory.text(),
          url: FieldTypeFactory.text(),
        },
      }),
      footerImageLinks: FieldTypeFactory.list({
        of: {
          actionImage: FieldTypeFactory.image(),
          actionUrl: FieldTypeFactory.text(),
        },
      }),
      isCentered: FieldTypeFactory.boolean({ required: false }),
    },
  }),
  contactMenu: {
    label: FieldTypeFactory.text(),
    socialItems: FieldTypeFactory.list({
      of: {
        url: FieldTypeFactory.text(),
        media: FieldTypeFactory.text(),
      },
    }),
  },
  buttonsMenus: FieldTypeFactory.list({
    of: {
      label: FieldTypeFactory.text({ required: false }),
      url: FieldTypeFactory.text({ required: false }),
      image: FieldTypeFactory.image(),
    },
  }),
  bottomStrip: FieldTypeFactory.list({
    of: {
      text: FieldTypeFactory.text(),
      url: FieldTypeFactory.text({ required: false }),
    },
  }),
  labels: {
    newsletterSubscribeSuccess: FieldTypeFactory.text({ required: true }),
    subscribeCallToAction: FieldTypeFactory.text({ required: true }),
    securePaymentWith: FieldTypeFactory.text({ required: true }),
    logisticPartners: FieldTypeFactory.text({ required: true }),
    mandatoryField: FieldTypeFactory.text({ required: true }),
    invalidEmail: FieldTypeFactory.text({ required: true }),
    enterEmail: FieldTypeFactory.text({ required: true }),
    newsletterEmailLabel: FieldTypeFactory.text(),
  },
}
